import React from "react";
import { Flex } from "theme-ui";
import Button from "../../optimizely-components/Utilities/Buttons/Button";
import { Icon } from "../../optimizely-components/Utilities/Icons/Icon";

interface LoanProductCardProps {
  title: string;
  subtitle?: string;
  hoverActive?: boolean;
  icon?: string | JSX.Element;
  width?: number;
  button: {
    text: string;
    href: string;
  };
  learnMoreLink: string;
  checklist?: string[];
}

const LoanProductCard = ({
  title,
  subtitle,
  button,
  icon,
  hoverActive,
  width,
  learnMoreLink,
  checklist,
}: LoanProductCardProps) => {
  return (
    <div
      sx={{
        width: [392, 423, null, 400, 444],
        p: "17px",
        display: "grid",
        placeItems: "center",
        borderRadius: "4px",
        border: "transparent 2px solid",
        cursor: "pointer",
        "&:hover": {
          transition: "all 0.3s ease",
          border: "#DADEE5 2px solid",
        },
      }}
    >
      <div
        sx={{
          display: "flex",
          flexDirection: "column",
          bg: hoverActive ? "brand.neutralGrey" : "brand.powderBlue",
          borderRadius: "4px",
          height: [550],
          width: "100%",
          "&:hover": {
            bg: "brand.neutralGrey",
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            transition: "all 0.3s ease",
            ".button": {
              bg: "brand.darkBlue",
              color: "white",
            },
          },
          transition: "all 0.3s ease",
        }}
      >
        <Flex
          sx={{
            alignItems: "center",
            justifyContent: "center",
            ml: [0, null, null, 0],
            mt: [4, null, null, "35px"],
            mb: "25px",
            flexDirection: ["column", null, null, "row"],
          }}
        >
          {icon && (
            <div
              className="circle"
              sx={{
                mr: 3,
              }}
            >
              {icon}
            </div>
          )}
          <div
            sx={{
              height: 50,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2 sx={{ variant: "text.h2New" }}>{title} </h2>
            {subtitle && <p sx={{ variant: "text.bodyNew" }}>{subtitle}</p>}
          </div>
        </Flex>
        {checklist && (
          <Flex
            as="ul"
            sx={{
              flexDirection: "column",
              pl: ["45px", null, null, "54px"],
              pb: "30px",
              height: "55%",
            }}
          >
            {checklist.map((item: string, i: number) => (
              <li
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  pb: ["13px", null, null, "16px"],
                  variant: "text.bodyNew",
                  listStyle: "none",
                }}
              >
                <div
                  sx={{
                    mr: 3,
                  }}
                >
                  <Icon
                    name={"check-mark-polka-dot"}
                    size={20}
                    alt="checkmark"
                    color="black"
                  />
                </div>
                <p
                  sx={{
                    maxWidth: 260,
                  }}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </Flex>
        )}
        <Flex
          sx={{
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <a
            className="button"
            href={button.href}
            sx={{
              bg: hoverActive ? "brand.darkBlue" : "white",
              color: hoverActive ? "white" : "black",
              variant: "buttons.newPrimary",
              width: 216,
              fontWeight: 600,
            }}
          >
            {button.text}
          </a>
          <a
            href={learnMoreLink}
            sx={{
              color: "black",
              mt: 3,
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            Learn More
          </a>
        </Flex>
      </div>
    </div>
  );
};

export default LoanProductCard;
